<template>
  <div id="app">
    <suspense>
      <router-view />
    </suspense>
    <div id="message-box" />
    <div id="mloading" class="loading">
      <div class="loading-cover" />
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <modals-container />
    <dialog-wrapper />
    <div class="fake-click" />

    <div id="msg-box-nps" class="msg-box-nps" style="display: none">
      <div id="msg-center-nps" class="form-popup-nps msg-center-nps">
        <iframe id="msg-content-nps" frameborder="0" />
      </div>
    </div>
    <!-- nvthinh 12.06.2025: Video player thu nhỏ độc lập -->
    <MinimizedVideoPlayer />
    <MsGettingStartedMini :progress-text="progressGettingStarted" />
  </div>
</template>

<script>
import {DialogWrapper} from 'vue3-promise-dialog';
import MsGettingStartedMini from '@/pages/MsGettingStartedMini.vue';
import MinimizedVideoPlayer from '@/components/MinimizedVideoPlayer.vue'; // nvthinh 12.06.2025
import commonFunction from '@/commons/commonFunction';

export default {
  components: {
    DialogWrapper,
    MsGettingStartedMini,
    MinimizedVideoPlayer,
  },
  data() {
    return {
      progressGettingStarted: '0/3',
    };
  },
  computed: {},
  watch: {},
  created() {},

  mounted() {
    const me = this;

    me.initEnterSameTab();
    commonFunction.hideMiniGettingStarted();
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          const tag = e.target.tagName.toLowerCase();
          if (['button', 'a'].indexOf(tag) > -1) {
            return;
          }

          if ('textarea' == tag && e.shiftKey) {
            return;
          }
          // Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          // Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (e.target.closest('.ms-grid-viewer') && e.target.closest('tbody')) {
            return;
          }
          // ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return;
          }
          const focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
